import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { StoreProvider } from "@/context/StoreContext";
import { CartProvider } from "@/context/CartContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { ScrollToTop } from "@/components/store/ScrollToTop";

import { StoreLayout } from "@/components/store/StoreLayout";
import Home from "@/pages/store/Home";
import Shop from "@/pages/store/Shop";
import ProductDetail from "@/pages/store/ProductDetail";
import Checkout from "@/pages/store/Checkout";
import PaymentCallback from "@/pages/store/PaymentCallback";
import Learn from "@/pages/store/Learn";
import BlogPost from "@/pages/store/BlogPost";
import Reviews from "@/pages/store/Reviews";
import About from "@/pages/store/About";
import Contact from "@/pages/store/Contact";
import TrackOrder from "@/pages/store/TrackOrder";
import Policy from "@/pages/store/Policy";

import AdminLogin from "@/pages/admin/AdminLogin";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import OrdersAdmin from "@/pages/admin/OrdersAdmin";
import CouponsAdmin from "@/pages/admin/CouponsAdmin";
import BlogAdmin from "@/pages/admin/BlogAdmin";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StoreProvider>
          <CartProvider>
            <AdminAuthProvider>
              <ScrollToTop />
              <Routes>
                <Route element={<StoreLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/payment/callback" element={<PaymentCallback />} />
                  <Route path="/learn" element={<Learn />} />
                  <Route path="/learn/:id" element={<BlogPost />} />
                  <Route path="/reviews" element={<Reviews />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/track" element={<TrackOrder />} />
                  <Route path="/policies/:slug" element={<Policy />} />
                </Route>

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="products" element={<ProductsAdmin />} />
                  <Route path="orders" element={<OrdersAdmin />} />
                  <Route path="coupons" element={<CouponsAdmin />} />
                  <Route path="blog" element={<BlogAdmin />} />
                  <Route path="testimonials" element={<TestimonialsAdmin />} />
                  <Route path="settings" element={<SettingsAdmin />} />
                </Route>
              </Routes>
              <Toaster position="top-center" richColors />
            </AdminAuthProvider>
          </CartProvider>
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
